class CollectionLayoutSwitcher extends window.BAO.CustomElement({
  SuperClass: HTMLUListElement,
}) {
  constructor () {
    super()

    this.state = {
      device: this.dataset.device,
    }
  }

  setupListeners () {
    super.setupListeners()
    this.els.trigger.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', this.handleTriggerClick.bind(this))
    })
  }

  handleTriggerClick (e) {
    const view = e.target.dataset.view

    this.currentView = view

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'plp_grid_view_switch',
      event_action: view,
    })
  }

  async setView () {
    const view = this.state.view
    const viewport = this.state.device
    if (!this.productGrid) return

    this.productGrid.dataset.view = view

    const dataView = `data-${viewport}-view`
    const dataColumns = `--${viewport}-columns`

    this.productGrid.setAttribute(dataView, view)
    this.productGrid.style.setProperty(dataColumns, view)

    this.els.trigger.elements.forEach(trigger => {
      const isPressed = trigger.dataset.view === view
      trigger.setAttribute('aria-pressed', isPressed)
    })

    await this.postCartAttribute()
  }

  async postCartAttribute () {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [this.itemKey]: this.currentView,
          },
        }),
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
    } catch (error) {
      console.error('Failed to update cart attribute:', error)
    }
  }

  get productGrid () {
    return document.querySelector(
      '[data-collection-filters-el="item-container"]',
    )
  }

  get itemKey () {
    return `_collection-view-${this.state.device}`
  }

  get currentView () {
    return this.state.view
  }

  set currentView (view) {
    this.state.view = view
    this.setView()
  }
}

customElements.define('collection-layout-switcher', CollectionLayoutSwitcher, {
  extends: 'ul',
})
